<script setup lang="ts">
</script>

<template>
    <a class="block rounded-lg border-2 border-black dark:border-white p-4 hover:scale-95 transition-all uppercase skyjo-text-xs cursor-pointer text-center">
        <slot></slot>
    </a>
</template>

<style scoped>
a {
    cursor: url("/resources/images/cursor.png"), pointer;
}
</style>
